import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

// Pages
import NotFound from '../views/NotFound'
import Login from '../views/Login'
import Registro from '../views/Registro'
import Registro_consumo from '../views/Registro_consumo'
import ResetPassword from '../views/ResetPassword'
import Logout from '../views/Logout'
import Dashboard from '../views/Dashboard'
import Producto from '../views/Producto'
import Perfil from '../views/Perfil'
import EditarPerfil from '../views/EditarPerfil'
import Comparador from '../views/Comparador'
import Favoritos from '../views/Favoritos'
import Busqueda from "../views/Busqueda";
import Presupuestos from "../views/Presupuestos";
import Tutoriales from "../views/Tutoriales";

// Routes
const router = new VueRouter({
    mode: 'history',
    linkActiveClass: 'is-active',
    routes: [
        {
            path: '/login',
            name: 'login',
            component: Login,
        },
        {
            path: '/registro',
            name: 'registro',
            component: Registro,
        },
        {
            path: '/registrarse',
            name: 'registrarse',
            component: Registro_consumo,
        },
        {
            path: '/reset/password',
            name: 'passwordreset',
            component: ResetPassword,
        },
        {
            path: '/logout',
            name: 'logout',
            component: Logout,
            meta: {
                requiresAuth: true,
            }
        },
        {
            path: '/perfil',
            name: 'perfil',
            component: Perfil,
            meta: {
                requiresAuth: true,
            }
        },
        {
            path: '/perfil/editar',
            name: 'editar-perfil',
            component: EditarPerfil,
            meta: {
                requiresAuth: true,
            }
        },
        {
            path: '/',
            name: 'dashboard',
            component: Dashboard,
            meta: {
                requiresAuth: true,
            }
        },
        {
            path: '/producto/:slug',
            name: 'producto',
            component: Producto,
            meta: {
                requiresAuth: true,
            }
        },
        {
            path: '/comparador/:producto_1',
            name: 'comparador',
            component: Comparador,
            meta: {
                requiresAuth: true,
            }
        },
        {
            path: '/buscar',
            name: 'busqueda',
            component: Busqueda,
            meta: {
                requiresAuth: true,
            }
        },
        {
            path: '/presupuestos',
            name: 'presupuestos',
            component: Presupuestos,
            meta: {
                requiresAuth: true,
            }
        },
        {
            path: '/favoritos',
            name: 'favoritos',
            component: Favoritos,
        },
        {
            path: '/tutorial',
            name: 'tutoriales',
            component: Tutoriales,
        },
        {
            path: '/404',
            name: '404',
            component: NotFound,
        },
        {
            path: '*',
            redirect: '/404',
        },
    ],
});

export default router
